module.exports = __webpack_public_path__ + "static/media/ABCDE_update.1b42c749.png";